<div class="p-3" *ngIf="view === 'chart'">
  <dx-chart palette="Bright"
            [dataSource]="sensor.history">

    <dxo-zoom-and-pan
      [dragToZoom]="true"
      valueAxis="none"
      argumentAxis="both"
    ></dxo-zoom-and-pan>

    <dxi-series argumentField="time" valueField="record"></dxi-series>

    <dxo-argument-axis argumentType="datetime"></dxo-argument-axis>
    <dxo-value-axis>
      <dxo-label [customizeText]="valueAxisAddUnit"></dxo-label>
    </dxo-value-axis>

    <dxo-common-series-settings width="2">
      <dxo-point [visible]="false"></dxo-point>
      <dxo-hover-style width="2"></dxo-hover-style>
    </dxo-common-series-settings>

    <dxo-size height="320"  width="100%"></dxo-size>

    <dxo-legend [visible]="false"></dxo-legend>

    <dxo-common-axis-settings>
      <dxo-grid [visible]="true"></dxo-grid>
    </dxo-common-axis-settings>

    <dxo-export [enabled]="false"></dxo-export>

    <dxo-tooltip contentTemplate="historyChartTooltip" [zIndex]="300000" argumentFormat="shortDateShortTime"
                 [enabled]="true"></dxo-tooltip>
    <div *dxTemplate="let info of 'historyChartTooltip'">
      <div>{{info.value | number}} {{sensor.unit}} - {{info.argumentText}}</div>
    </div>
  </dx-chart>
</div>

<div *ngIf="view === 'table'">
  <dx-data-grid
    [dataSource]="sensor.history"
    [showRowLines]="true"
    height="320"
    [rowAlternationEnabled]="false"
    [hoverStateEnabled]="true"
    [columnAutoWidth]="true"
    [showBorders]="false">

    <dxi-column
      caption="Date"
      dataType="date"
      format="shortDateShortTime"
      dataField="time">
    </dxi-column>

    <dxi-column
      [caption]="'Niveau' + (sensor.unit ? ' (' + sensor.unit + ')' : '')"
      format="#0.##"
      dataField="record">
    </dxi-column>
  </dx-data-grid>
</div>


